<template>
  <v-row>
    <v-col cols="12">
      <!-- Procedural Subjects Table  -->
        <!-- :items="docsDeActuaciones ? documentosActuaciones(gidActuacion) : getDocumentos" -->
      <v-data-table
        :headers="headers"
        :items="docsDeActuaciones ? getDocumentosActuaciones : getDocumentos"
        :itemsPerPage="10000" 
        hide-default-footer
        no-data-text="El registro no posee documentos registrados"
        class="elevation-1 capgit tion"
        style="background: transparent"
        :loading="getStatus.loading"
        loading-text="Cargando... Por favor espere"
      >
        <!-- <template v-slot:item="{ item }"> -->
        <template v-slot:item.type="{ item }">
          <v-btn
            class="transparent"
            @click="downloadFile(item.idRegDocumento, item.nombre)"
            text
            fab
            width="18"
            height="18"
            dark
          >
            <v-icon
              v-if="isLoading != item.idRegDocumento"
              aria-hidden="true"
              aria-label="info"
              size="18"
              class="mt-n2"
              color="primary"
              >fas fa-file</v-icon
            >
            <v-progress-circular
              v-if="isLoading == item.idRegDocumento"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-btn>
        </template>
      </v-data-table>
      <!--paginacion -->
    </v-col>
    <v-col class="text-center">
      <v-dialog v-model="show" width="500">
        <Notifier
          v-if="show && consulted"
          :message="message"
          @close="show = false"
        />
      </v-dialog>
    </v-col>
  </v-row>
</template>
<script>
import axios from '@/config/axios';
import { mapGetters, mapActions } from 'vuex';
import Notifier from '../Notifier';
import mime from 'mime';

export default {
  components: { Notifier },
  props:{
    docsDeActuaciones: {
      type: Boolean,
      default: false
    }
    // // gidActuacion: Number
  },
  data: () => ({
    isLoading: '',
    show: false,
    consulted: false,
    message: '', 
    headers: [
      {
        text: 'Nombre',
        value: 'nombre',
        class:
          'grey--text text--darken-3 body-1 font-weight-bold blue-grey lighten-5',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Descripción',
        value: 'descripcion',
        class:
          'grey--text text--darken-3 body-1 font-weight-bold blue-grey lighten-5',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Descargar',
        value: 'type',
        class:
          'grey--text text--darken-3 body-1 font-weight-bold blue-grey lighten-5',
        align: 'center',
        sortable: false,
      },
    ],
    message:
      'La consulta no generó resultados, por favor revisar las opciones ingresadas e intentarlo nuevamente',
  }),
  computed: {
    ...mapGetters('process', [
      'getProcesos',
      'getDetails',
      'getDocumentos',
      'getDocumentosActuaciones',
      'getStatus'
    ]),
  },
  methods: {
    ...mapActions('process',['documentosActuaciones']),
    downloadFile(idDocumento, nameDocumento) {
      this.isLoading = idDocumento;

      axios({
        // url: `/Descarga/DocumentoProceso/${idDocumento}`,
        url: `/Descarga/Documento/${idDocumento}`,
        method: 'GET',
        responseType: 'blob',
      })
        .then((response) => {
          let date = new Date();
          let today = `${
            date.getFullYear() < 10
              ? `0${date.getFullYear()}`
              : date.getFullYear()
          }${
            date.getMonth() + 1 < 10
              ? `0${date.getMonth() + 1}`
              : date.getMonth() + 1
          }${date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()}`;
          let hour = `${
            date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()
          }${
            date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()
          }${
            date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds()
          }`;
          
          // // // let ext = mime.getExtension(response.headers['content-type']);
          // // // let nombre =
          // // //   ext == 'bin' ? `${nameDocumento}.DOC` : `${nameDocumento}.${ext}`;
          
          /*  Obtener el nombre enviado desde del server, se ha de habilitar 
              la cabecera: 'content-disposition' */
          let nombre =
            response.headers['content-disposition'].split('filename=')[1].split(';')[0];

          // Si no se logra extraer el nombre de archivo desde la cabecera
          if (nombre === undefined){
            let ext = mime.getExtension(response.headers['content-type']);
            nombre =
              ext == 'bin' ? `${nameDocumento}.DOC` : `${nameDocumento}.${ext}`;
          }


          let blob = new Blob([response.data]);
          let fileURL = window.URL.createObjectURL(blob);
          let fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute('download', nombre);
          document.body.appendChild(fileLink);

          fileLink.click();
          this.isLoading = '';
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = '';
          this.consulted = true;
          this.show = true;
          this.message = 
            `${err.message}.\nEl documento solicitado no está disponible en este momento, por favor intente más tarde.`;
        });
    },
  },
  // // created() {
  // //   
  // //   await this.$store.dispatch("process/documentosActuaciones", gidActuacion)    
  // // }
  // // // created() {
  // // //   
  // // //   this.documentosActuaciones(this.gidActuacion)    
  // // // }

};
</script>
